export default function PublicRegistrationClosed() {
  return (
    <main className="mx-auto max-w-2xl p-4 text-center">
      <h1 className="text-2xl font-bold">Inscrições encerradas</h1>
      <p className="mt-2 text-gray-700">Este seletivo não está aceitando inscrições no momento.</p>
    </main>
  );
}
